import React from "react";
import withLocalization from "../../../hoc/with-localization";

import "./page1-footer.scss";

const Page1Footer = props => {
    const { doctorName, resultDate, signInfo: { signed, stampImg, signatureImg } = {}, loc } = props;
    let elStamp = null,
        elSignature = null;
    if (signed) {
        elStamp = stampImg ? (
            <div className="signature__stamp">
                <img src={stampImg} alt="organization stamp" />
            </div>
        ) : null;

        elSignature = signatureImg ? (
            <div className="signature__hand-sign">
                <img src={signatureImg} alt="doctor signature" />
            </div>
        ) : null;
    }

    return (
        <div className="page1-footer">
            <div className="doctor-signature">
                <span className="doctor-signature__block1">{loc("report.labels.doctor")}</span>
                <div className="doctor-signature__block2">
                    <span className="doctor-signature__images">
                        {elSignature}
                        {elStamp}
                    </span>
                    <span className="doctor-signature__signatureArea">&nbsp;</span>
                    <span className="doctor-signature__doctor-name">
                        <span>/</span>
                        <span className={"doctor-name__value" + (doctorName ? "" : " empty")}>{doctorName}</span>
                        <span>/</span>
                    </span>
                </div>
            </div>

            <div className="page1-footer__result-date">
                <span>{loc("report.labels.date")}</span>
                <span>{resultDate}</span>
            </div>
        </div>
    );
};

export default withLocalization(Page1Footer);
